export default __webpack_public_path__ + "static/media/kerala.69fe4d26.jpg";